import React, {useEffect} from "react";
import images from "components/UI/images";
import {navLinks, socialList} from "components/Header";
import ModalSubscribe from "./UI/Modal/ModalSubscribe";
import socials from "components/UI/icons/socials";
import icons from "components/UI/icons/icons";

const Footer: React.FC = () => {
    const {ImageLogo} = images;
    const {IconEmail} = icons;
    const [btnAnime, setBtnAnime] = React.useState<boolean>(false);
    const [isModalSubscribeOpen, setIsModalSubscribeOpen] = React.useState<boolean>(false);

    useEffect(() => {
        const interval = setInterval(() => {
            setBtnAnime(true);
            setTimeout(() => {
                setBtnAnime(false);
            }, 1500)
        }, 6000);

        return () => clearInterval(interval);
    }, []);

    const openModalSubscribe = () => {
        setIsModalSubscribeOpen(true)
    }

    return (
        <footer className="footer">
            <div className="footer__container">
                <div className="footer__row">
                    <div className="footer__col">
                        <img className="footer__logo" src={ImageLogo} alt="Iggy Boy NFT"/>
                    </div>
                    <div className="footer__col footer__nav">
                        <ul className="footer__nav-list">
                            {
                                navLinks.map((link, index) => (
                                    <li key={index}>
                                        <a href={link.url} target="_blank"
                                           rel="noreferrer" className="footer__nav-link">{link.text}</a>
                                    </li>
                                ))
                            }
                        </ul>
                        <span className="footer__separator"/>
                        <ul className="footer__socials">
                            {
                                socialList.map((social, index) => {
                                    const {url, text, icon} = social;
                                    const Icon = socials[icon];

                                    return <li key={index}>
                                        <a href={url} target="_blank" rel="noreferrer" aria-label={text}
                                           className="footer__socials-link">
                                            <Icon/>
                                        </a>
                                    </li>
                                })
                            }
                        </ul>
                        <span className="footer__separator"/>
                        <button
                                onClick={openModalSubscribe}
                                className={`footer__subscribe ${btnAnime ? "footer__subscribe--anime" : ""}`}>
                                Subscribe
                            </button>
                        <span className="footer__separator"/>
                    </div>
                </div>
                <div className="footer__row footer__bottom">
                    <span className="footer__policy">Privacy Policy</span>
                    <span>&copy; Copyright 2021-2022</span>
                    <span>All rights reserved. Powered by 1ATH.Studio</span>
                    <span>Contact us: <IconEmail/></span>
                </div>
            </div>
            <ModalSubscribe isOpen={isModalSubscribeOpen} setIsOpen={setIsModalSubscribeOpen}/>
        </footer>
    );
};

export default Footer;